<style lang="scss" scoped>
@import './login.scss';
</style>
<style lang="scss">
.log-body {
  .el-input {
    .el-input__inner {
      height: 38px;
    }
  }
  .log-btn {
    width: 200px;
    margin: 0 auto;
    display: block;
    height: 40px;
    background-color: #3276d5;
  }
}
</style>
<template>
  <div>
    <div
      class="log-body"
      :style="{
        backgroundImage: 'url(' + login_bg + ')',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }"
    >
      <div class="log-container">
        <div
          name="admin"
          label="管理员登录(shopexid)"
        >
          <div class="log-img" />
          <el-form
            ref="ruleForm1"
            :model="ruleForm1"
            :rules="rules1"
            label-position="left"
            label-width="0px"
            class="login-log-container"
          >
            <h3 class="title">
              <el-button
                type="text"
                style="float: right; color: #ff5000"
                @click="$router.push({ path: '/qwAuth/register' })"
              >
                免费注册
              </el-button>
            </h3>
            <div style="text-align: center; width: 100%">
              <img
                class="image"
                :src="require('@/assets/img/qwLogin/loginLeft.png')"
                alt=""
                style="height: 154px"
              >
            </div>

            <!-- dev login -->
            <div v-if="status == 'dev' || status == 'uat'">
              <el-form-item prop="account">
                <el-input
                  v-model="ruleForm1.account"
                  type="text"
                  name="account"
                  auto-complete="off"
                  placeholder="请输入手机号"
                />
              </el-form-item>
              <el-form-item prop="checkPass">
                <el-input
                  v-model="ruleForm1.checkPass"
                  type="password"
                  name="password"
                  auto-complete="off"
                  placeholder="密码"
                />
              </el-form-item>
              <el-form-item class="log-opr clearfix">
                <el-checkbox
                  v-model="checked"
                  checked
                  class="remember f_l"
                >
                  记住密码
                </el-checkbox>
                <a
                  href="https://account.shopex.cn/forget?"
                  target="_blank"
                  class="forget-pwd"
                >忘记密码</a>
              </el-form-item>
            </div>
            <!-- dev login -->
            <div v-if="status == 'dev' || status == 'uat'">
              <el-button
                type="primary"
                class="log-btn"
                :loading="logining"
                :disabled="submitDisabled"
                @click.native.prevent="handleSubmit1"
              >
                登录
              </el-button>
            </div>
            <SpQwAuth />
          </el-form>
        </div>
      </div>
    </div>
    <!-- <BindPhoneDialog /> -->
  </div>
</template>

<script>
import loginMixin from './loginMixin'
// import bindPhone from '@/view/qwAuth/comps/bindAccount/bindPhoneDialog.vue'
export default {
  components: {
    // 'BindPhoneDialog':bindPhone
  },
  mixins: [loginMixin],
  mounted () {
    localStorage.setItem('isShowTopNotice', true)
  },
  methods: {}
}
</script>
